import { theme } from '@theme';
import styled from 'styled-components';

export const HeaderContainer = styled.div`
  @media print {
    display: none !important;
  }

  .navbar .navbar-collapse > .navbar-nav {
    &.user-menu {
      float: none !important;
      flex: 1;
      flex-grow: 2;
      flex-direction: row-reverse;

      > li {
        position: relative;
        height: 60px;
        width: auto;
        font-weight: ${theme.typography.fontWeights.semibold};

        &.disable {
          background-color: ${theme.palette.transparent};

          > ul {
            display: none;
          }
        }

        > a {
          color: ${theme.palette.text.white};
          line-height: 34px;
          cursor: pointer;

          &.navbar-menu {
            padding-left: 12px;
            padding-right: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 102px;

            .am-icon {
              position: relative;
            }
          }
        }

        &:last-of-type {
          &:hover {
            > ul {
              display: block;
            }
          }
        }

        .navbar-icon,
        .brand-id {
          color: ${theme.palette.text.white};
          box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.3);
          font-size: 150%;
          display: inline-flex;
          align-items: center;
          padding: 15px;
          height: 60px;
          float: left;
        }

        .brand-id {
          color: rgba(255, 255, 255, 0.6);
          font-size: 215%;
          padding: 16px 11px;

          &:hover {
            cursor: default;
          }
        }

        @media (max-width: 767px) {
          .brand-id {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      }

      .support-tooltip {
        position: absolute;
        right: 15px;
        width: 600px;
        background-color: ${theme.palette.text.white};
        top: 100%;
        margin-top: 5px;
        border: 1px solid ${theme.palette.disabledGrey};
        box-shadow: 0 1px 9px -3px rgba(0, 0, 0, 0.4);

        .support-header {
          &:after,
          &:before {
            bottom: 100%;
            right: 20px;
            border: solid ${theme.palette.transparent};
            content: ' ';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
          }

          &:after {
            border-color: ${theme.palette.transparent};
            border-bottom-color: ${theme.palette.basicGrayTwo};
            border-width: 13px;
            margin-left: -13px;
          }

          &:before {
            border-color: ${theme.palette.transparent};
            border-bottom-color: ${theme.palette.lightGrayFive};
            border-width: 14px;
            margin-left: -14px;
          }
        }
      }
    }
  }

  .navbar {
    background-color: ${theme.palette.text.purple};
    background-image: linear-gradient(
      to bottom,
      ${theme.palette.purpleFive} 0%,
      ${theme.palette.darkPurpleFour} 100%
    );
    height: 60px;
    border: 0;
    margin: 0;
    transition: all 0.2s linear;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
    z-index: 200;

    @include respond(Mobile) {
      box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
    }

    .navbar-button {
      border-left: 1px solid ${theme.palette.darkPurpleFive};
      border-right: 1px solid ${theme.palette.purpleSix};
      float: left;
      position: relative;
      display: block;
      height: 60px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
        cursor: pointer;
        a {
          transition: border-bottom-width 0.15s ease-in;
          border-bottom-width: 6px;
        }
      }

      > span {
        height: 60px;
        padding: 15px 18px;
        line-height: 30px;
        transition: border-bottom-width 0.15s ease-in;
        border-bottom-width: 0px;
        position: relative;
        color: ${theme.palette.text.white};
        -webkit-touch-callout: none;
        user-select: none;
        user-select: none;
        display: block;
        text-decoration: none;
      }
    }

    .navbar-collapse {
      display: block;
      height: auto;
      overflow: visible;
      padding: 0;
      margin: 0;
      border: none;
      display: flex !important;

      > .navbar-nav {
        float: left;
        list-style: none;
        margin: 0;
        > li {
          border-left: 1px solid ${theme.palette.darkPurpleFive};
          border-right: 1px solid ${theme.palette.purpleSix};
          float: left;
          display: flex;
          align-items: center;

          &:hover,
          &.open {
            &:not(.active) {
              background-color: rgba(0, 0, 0, 0.1);
              cursor: pointer;

              &#Lease a {
                border-bottom: 6px solid ${theme.palette.leaseColor};
              }
              &#Finance a {
                border-bottom: 6px solid ${theme.palette.yellow};
              }
              &#Cash a {
                border-bottom: 6px solid ${theme.palette.green};
              }
              a {
                transition: border-bottom-width 0.15s ease-in;
                border-bottom-width: 6px;
              }
            }
          }
          &[app-brand-icon]:hover {
            background-color: ${theme.palette.transparent};
          }

          > a {
            height: 60px;
            padding: 15px 18px;
            line-height: 30px;
            transition: border-bottom-width 0.15s ease-in;
            border-bottom-width: 0px;
            position: relative;
            color: ${theme.palette.text.white};
            user-select: none;
          }
        }
        &.deal-icon-menu {
          // TODO: remove once complete header is migrated.
          display: flex;
          @include respond-to(to_lmd) {
            display: none;
          }
          @include respond-to(xs) {
            display: none;
          }
        }
        &.filter_menu {
          border-right: 1px solid ${theme.palette.darkPurpleFive};

          @include respond-to(Phone) {
            display: block;
          }

          > li {
            > a {
              text-decoration: none;
              color: ${theme.palette.text.white};
              text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
              text-transform: uppercase;
              font-weight: ${theme.typography.fontWeights.semibold};
              font-size: ${theme.typography.fontSize}px;
            }
            &.active {
              > a {
                background-color: ${theme.palette.transparent};
                color: ${theme.palette.text.purple};
                text-shadow: none;
                cursor: default;
              }
            }
          }
        }
        &.top-search {
          position: relative;
          width: 100%;
          max-width: 350px;
          flex: 1;
          flex-grow: 2.1;

          .search-btn {
            display: none;
            width: 100%;
            height: 60px;
            line-height: 60px;
            position: relative;
            color: ${theme.palette.text.white};
            text-align: center;
            &:hover,
            &:focus {
              text-decoration: none;
            }
            .am-icon {
              font-size: 170%;
              vertical-align: middle;
            }
          }

          @include response(vpn) {
            .search-btn {
              display: inline-block;
            }
          }
        }

        @media (max-width: 479px) {
          &.top-search {
            form {
              padding: 10px;
              width: 100%;
              height: 50px;
              left: 0;
              right: 0;
              .am-icon-loupe {
                font-size: 140%;
                top: 15px;
                left: 14px;
              }
            }
          }
        }
      }

      @media (max-width: 992px) {
        .navbar-nav {
          &.top-search {
            float: left;
          }

          &.filter_menu > li > a,
          .navbar-button > a {
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      }

      @media (max-width: 895px) {
        .navbar-nav.user-menu > li {
          > a.navbar-menu {
            span {
              display: inline;
            }
          }
        }
      }
      @media (max-width: 767px) {
        .navbar-nav {
          &.user-menu > li {
            > a.navbar-menu,
            .badge-item {
              padding-left: 12px;
              padding-right: 12px;
              text-align: center;
            }
            &:last-of-type {
              > a.navbar-menu {
                .am-icon {
                  padding-right: 10px;
                  font-size: 200%;
                  vertical-align: middle;
                }
                span {
                  display: none;
                }
              }
            }
          }
          &.navbar-right {
            margin-right: -15px;
          }

          &.filter_menu {
            display: none;
          }

          .mobile-search {
            box-shadow: inset 1px 0 0 ${theme.palette.toolTipBackground};
          }
        }
      }
      @media (min-width: 767px) and (max-width: 895px) {
        .navbar-nav {
          &.navbar-right.user-menu {
            > li {
              > a {
                &.navbar-menu {
                  max-width: 120px;
                }
              }
            }
          }
        }
      }
      @media (min-width: 992px) {
        .navbar-nav {
          &.navbar-right.user-menu {
            > li {
              > a {
                &.navbar-menu {
                  max-width: 120px;
                }
              }
            }
          }
        }
      }

      @media (max-width: 479px) {
        .navbar-nav {
          &.user-menu {
            > li {
              &:not(.badge-item) {
                position: static;
              }
              > ul {
                left: 0;
                right: 0;
                li {
                  font-size: ${theme.typography.fontSize16}px;
                  height: 45px;
                  a {
                    line-height: 44px;
                  }
                }
              }
            }
          }
          &.top-search {
            width: 38px;
            position: static;
          }
        }
        .deal-icon-menu li a,
        .filter_menu > li > a {
          padding-left: 7px;
          padding-right: 7px;
        }
      }

      @media (max-width: 599px) {
        .user-menu li .brand-id {
          display: none;
        }
      }

      @media (min-width: 479px) {
        form.collapse {
          display: block;
          margin-left: 10px;
          margin-right: 10px;
        }
      }

      @include response(vpn) {
      }
    }
  }

  .user-menu {
    float: none !important;
    flex: 1;
    flex-grow: 2;
  }

  .active-background {
    background-color: ${theme.palette.lightPurpleTen};
  }

  .reports-nav-button {
    text-decoration: none;
    color: ${theme.palette.text.white};
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    font-weight: ${theme.typography.fontWeights.semibold};
    font-size: ${theme.typography.fontSize16}px;
    text-transform: unset;
  }

  .reports-nav-button-active {
    background-color: ${theme.palette.transparent} !important;
    color: ${theme.palette.text.purple} !important;
    text-shadow: none !important;
    cursor: default;
  }
`;

export const NavbarHeader = styled.div<{ isMobileDevice: boolean }>`
  float: left;
  padding: ${(props) => (props.isMobileDevice ? `0 10px` : `0`)};
  border-right: ${(props) =>
    props.isMobileDevice ? `1px solid ${theme.palette.darkPurpleSix}` : ''};

  img {
    height: 60px;
    width: ${(props) => (props.isMobileDevice ? `45` : `200`)}px;
    padding: ${(props) => (props.isMobileDevice ? `` : `18`)}px;
    cursor: pointer;
  }

  &:active {
    position: relative;
    top: 1px;
    opacity: 0.9;
  }
`;

export const NotificationButton = styled.li.attrs({
  className: 'notification-button',
})`
  position: relative;
  height: 60px;
  width: auto;
  font-weight: ${theme.typography.fontWeights.semibold};
  border-left: 1px solid ${theme.palette.darkPurpleFive};
  border-right: 1px solid ${theme.palette.toolTipBackground};
  float: right;

  &.disable {
    background-color: ${theme.palette.transparent};
    > ul {
      display: none;
    }
  }
  &:first-of-type {
    box-shadow: inset 1px 0 0 ${theme.palette.toolTipBackground};
  }
`;
